export default __webpack_public_path__ + "static/media/applyStatusIcon.08683355.svg";